import { 
  createCustomField as apiCreateCustomField,
  updateCustomField as apiUpdateCustomField,
  deleteCustomField as apiDeleteCustomField,
  createCustomFieldOption as apiCreateCustomFieldOption,
  deleteCustomFieldOption as apiDeleteCustomFieldOption
} from "../api/custom_fields";
import { 
  createChecklist as apiCreateChecklist,
  updateChecklist as apiUpdateChecklist,
  deleteChecklist as apiDeleteChecklist,
  updateChecklistPosition as apiUpdateChecklistPosition
} from "../api/checklists";
import { updateStatus as apiUpdateStatus } from "../api/statuses";
import { notification } from "antd";



export async function createCustomField(statusId, checklistId, data) {
  try {
    const result = await apiCreateCustomField(statusId, checklistId, data);
    // Валидация ответа: необходим корректный id
    if (!result || (typeof result.id !== 'number' && typeof result.id !== 'string')) {
      throw new Error('Сервер вернул некорректный ответ при создании поля');
    }
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось создать кастомное поле', placement: 'bottomRight' });
    throw error;
  }
}

export async function updateCustomField(statusId, checklistId, cfId, data) {
  try {
    const result = await apiUpdateCustomField(statusId, checklistId, cfId, data);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось обновить кастомное поле', placement: 'bottomRight' });
    throw error;
  }
}

export async function deleteCustomField(statusId, checklistId, cfId) {
  try {
    const success = await apiDeleteCustomField(statusId, checklistId, cfId);
    return success;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось удалить кастомное поле', placement: 'bottomRight' });
    throw error;
  }
}

export async function createCustomFieldOption(statusId, checklistId, cfId, option) {
  try {
    const result = await apiCreateCustomFieldOption(statusId, checklistId, cfId, option);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось создать опцию поля', placement: 'bottomRight' });
    throw error;
  }
}

export async function deleteCustomFieldOption(statusId, checklistId, cfId, optionId) {
  try {
    const success = await apiDeleteCustomFieldOption(statusId, checklistId, cfId, optionId);
    return success;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось удалить опцию поля', placement: 'bottomRight' });
    throw error;
  }
}

export async function createChecklist(statusId, data) {
  try {
    const result = await apiCreateChecklist(statusId, data);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось создать чеклист', placement: 'bottomRight' });
    throw error;
  }
}

export async function updateChecklist(statusId, checklistId, data) {
  try {
    const result = await apiUpdateChecklist(statusId, checklistId, data);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось обновить чеклист', placement: 'bottomRight' });
    throw error;
  }
}

export async function deleteChecklist(statusId, checklistId) {
  try {
    const result = await apiDeleteChecklist(statusId, checklistId);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось удалить чеклист', placement: 'bottomRight' });
    throw error;
  }
}

export async function updateChecklistPosition(statusId, checklistId, position) {
  try {
    const result = await apiUpdateChecklistPosition(statusId, checklistId, position);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось изменить позицию чеклиста', placement: 'bottomRight' });
    throw error;
  }
}

export async function updateStatus(statusId, data) {
  try {
    const result = await apiUpdateStatus(statusId, data);
    return result;
  } catch (error) {
    notification.error({ message: 'Ошибка', description: 'Не удалось обновить статус', placement: 'bottomRight' });
    throw error;
  }
} 